module.exports = __webpack_public_path__ + "static/media/RCP_FAQs.a4900056.pdf";